import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ChangePassword() {
  const [current, setCurrent] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { changePassword } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (newPass !== confirm) { setError('Senhas não conferem'); return; }
    if (newPass.length < 8) { setError('Senha deve ter no mínimo 8 caracteres'); return; }

    setLoading(true);
    try {
      await changePassword(current, newPass);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao trocar senha');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-base">
      <div className="w-[380px]">
        <div className="bg-surface-100 border rounded-md p-6">
          <h2 className="text-lg font-semibold mb-4">Troca de Senha Obrigatória</h2>
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="p-3 rounded-md text-sm mb-4 bg-status-rejected/10 text-status-rejected border border-status-rejected/20">
                {error}
              </div>
            )}
            <div className="mb-4">
              <label className="block text-sm font-medium text-ink-secondary mb-1">Senha Atual</label>
              <input type="password" className="form-input" value={current}
                onChange={(e) => setCurrent(e.target.value)} required />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-ink-secondary mb-1">Nova Senha</label>
              <input type="password" className="form-input" value={newPass}
                onChange={(e) => setNewPass(e.target.value)} required />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-ink-secondary mb-1">Confirmar Nova Senha</label>
              <input type="password" className="form-input" value={confirm}
                onChange={(e) => setConfirm(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary w-full" disabled={loading}>
              {loading ? 'Salvando...' : 'Trocar Senha'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
